import SignInComponent from "../MVPComponents/auth/SignInComponent";

const SignIn = () => {
  return (
    <div>
      <SignInComponent />
    </div>
  );
};

export default SignIn;
